// The hand-offs that make media → template → campaign one flow rather than three screens.
//
// Each step opens the next pre-filled: a media item opens the template composer with its text and
// picture, and an approved template opens a new campaign with itself and that media chosen. The
// links live here so the media builder, the media library, the templates page and the campaign
// wizard all agree on what they look like — the receiving page reads exactly these parameters.

/** The templates page, opening the composer pre-filled from this media item. */
export const templateFromMediaPath = (workspaceId: string, mediaId: string) =>
  `/w/${workspaceId}/whatsapp-templates?fromMedia=${encodeURIComponent(mediaId)}`;

/** A new WhatsApp campaign, starting from this (approved) template and its default media. */
export const campaignFromTemplatePath = (workspaceId: string, templateId: string) =>
  `/w/${workspaceId}/campaigns/new?channel=whatsapp&template=${encodeURIComponent(templateId)}`;

export type MediaHandOff = 'template' | 'campaign' | null;

/**
 * Where a media item's call to action leads.
 *
 * To a template for anyone who can make one — the generated text is only usable as a template's
 * body. Everyone else (a content role, a plan without custom templates) keeps "Use in a campaign",
 * which still picks from the templates the workspace already has; otherwise they would be left
 * with no way forward from their own media at all.
 */
export const mediaHandOff = ({
  canManageTemplates, hasCustomTemplates, canCreateCampaign,
}: { canManageTemplates: boolean; hasCustomTemplates: boolean; canCreateCampaign: boolean }): MediaHandOff => {
  if (canManageTemplates && hasCustomTemplates) return 'template';
  if (canCreateCampaign) return 'campaign';
  return null;
};
